import React from 'react';
import { NavLink } from 'react-router-dom';

const LINKS = [
  { to: '/member/dashboard', label: 'Dashboard' },
  { to: '/member/membership', label: 'My Membership' },
  { to: '/member/cases', label: 'My Cases' },
  { to: '/member/documents', label: 'Documents' },
  { to: '/member/messages', label: 'Messages' },
  { to: '/member/appointments', label: 'Appointments' },
  { to: '/member/referral', label: 'Referral Programme' },
];

export default function MemberLayout({ title, children }) {
  return (
    <div className="dashboard-layout">
      <aside className="dashboard-sidebar">
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? 'active' : '')}>
            {l.label}
          </NavLink>
        ))}
      </aside>
      <div className="dashboard-main">
        {title && <h2 style={{ marginBottom: 24 }}>{title}</h2>}
        {children}
      </div>
    </div>
  );
}
